import React, { useMemo } from 'react';

import { Table } from './Table';
import { Layout } from './Layout';
import { ListingProps } from '../types';
import { useListingSelection } from '../useListingSelection';

export const Listing = <Data extends Record<string, any>, Context extends any = any>({
  onEmit,
  groups,
  columns,
  tableData,
  pagination,
  maxHeight,
  selection,
  injectContext,
  loading = false,
  staticSettings,
  renderRowDetail,
  ...layoutProps
}: ListingProps<Data, Context>) => {
  const context = injectContext || ({ context: 'Empty' } as Context);

  const allRows = useMemo<Data[]>(
    () => (groups ? groups.flatMap(group => group.data) : tableData),
    [groups, tableData]
  );

  const { selected, selectionColumn, clearSelection } = useListingSelection<Data, Context>(allRows, selection);

  const tableColumns = useMemo(
    () => (selection ? [selectionColumn, ...columns] : columns),
    [selection, selectionColumn, columns]
  );

  return (
    <Layout<Context>
      context={context}
      selected={selected}
      onCloseBulkActions={clearSelection}
      table={
        <Table<Data, Context>
          groups={groups}
          onEmit={onEmit}
          loading={loading}
          context={context}
          columns={tableColumns}
          tableData={tableData}
          pagination={pagination}
          maxHeight={maxHeight}
          staticSettings={staticSettings}
          renderRowDetail={renderRowDetail}
        />
      }
      {...layoutProps}
    />
  );
};
